import React, { Component } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import Uri from "jsuri";

import {
  sortNumeric,
  selectFormat,
  TableContentCell,
  Error,
  getMetricForColumn,
} from "./../../Utils/Utils.js";

class InstagramMediaMetrics extends Component {
  componentDidMount() {
    this.props.childRef(this);
  }

  renderTable(data) {
    const { cells, title, url } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "timestamp",
        text: "Date Posted",
        csvFormatter: (cell, row) => row && (row.date_pub ? row.date_pub : ""),
        hidden: true,
      },
      {
        dataField: "title",
        text: "Title",
        headerClasses: "sticky-column",
        style: { width: "320px", minWidth: "320px", textAlign: "left" },
        headerAlign: "left",
        classes: "sticky-column",
        formatter: TableContentCell,
        formatExtraData: {
          name: new Uri(url).hasQueryParam("p")
            ? new Uri(url).getQueryParamValue("p")
            : url.split("/")[2],
        },
        csvFormatter: (cell, row) => row && (row.title || row.tweet_text || ""),
        sort: true,
        filter: textFilter({
          getFilter: (filter) => filter,
          placeholder: " ",
          className: "custom-table-filter-input",
          caseSensitive: false,
        }),
      },
      {
        dataField: "handle",
        text: "Handle",
        style: { width: "90px", minWidth: "90px", textTransform: "capitalize" },
        sort: true,
      },
      {
        dataField: "type",
        text: "Type",
        style: { width: "90px", minWidth: "90px", textTransform: "capitalize" },
        sort: true,
      },
      {
        dataField: "impressions",
        text: "Impressions",
        style: { width: "90px", minWidth: "90px", textTransform: "capitalize" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "reach",
        text: "Reach",
        style: { width: "65px", minWidth: "65px", textTransform: "capitalize" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagement",
        text: "Engagement",
        style: { width: "100px", minWidth: "100px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,00"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "engagement_rate",
        text: "Engagement Rate",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percent", format: "0.00%" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "saved",
        text: "Saved",
        style: { width: "90px", minWidth: "90px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_views",
        text: "Video Views",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0,0"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "video_view_rate",
        text: "Video View Rate",
        style: { width: "120px", minWidth: "120px" },
        formatter: getMetricForColumn,
        formatExtraData: { type: "percentage", format: "%0.00" },
        csvFormatter: (cell) =>
          selectFormat("csv_number", cell && cell.value, "0.00%"),
        sort: true,
        sortFunc: sortNumeric,
      },
      {
        dataField: "url",
        text: "URL",
        hidden: true,
      },
    ];

    let selected_columns = columns;

    const defaultSorted = [
      {
        dataField: "impressions",
        order: "desc",
      },
    ];

    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const paginate = paginationFactory({
      sizePerPage: 10,
      hideSizePerPage: true,
    });

    const filename = title.split(" ").join("_") || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            pagination={paginate}
            defaultSorted={defaultSorted}
            filter={filterFactory()}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  builtInExportCSV = () => this.childRef;

  render() {
    const { data } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return <div>{this.renderTable(data.data)}</div>;
  }
}

export default InstagramMediaMetrics;
